<template lang="pug">
  .page-container
    .app-breadcrumbs
      v-container.breadcrumbs-container
        img.breadcrumbs-logo(src="../../assets/logo.png")/
        v-breadcrumbs(:items="breadcrumbs")
          template(slot="item" slot-scope="props")
            router-link(
              :to="props.item.to"
              class="app-breadcrumbs__item"
            ) {{ props.item.text }}

    v-container
      v-form.form-content(ref="form")
        v-layout
          v-flex
            v-text-field(
              :rules="fieldRules"
              :label='$t("changePassword.password")'
              outline
              v-model="password"
              ref="password"
              type="password"
            )

        v-layout
          v-flex
            v-text-field(
              :rules="fieldRules"
              :label='$t("changePassword.newPassword")'
              outline
              v-model="newPassword"
              ref="newPassword"
              type="password"
            )
        v-btn.btn(color="primary" round block @click="submit" :loading='isLoading') {{ $t("changePassword.confirmChange") }}

</template>

<script>
import account from "../../api/account.js";

export default {
  data() {
    return {
      password: null,
      newPassword: null,
      isLoading: false
    };
  },
  computed: {
    fieldRules() {
      return [value => !!value || this.$t("changePassword.required")];
    },
    form() {
      return {
        password: this.password,
        newPassword: this.newPassword
      };
    },
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("nav.home")
        },
        {
          to: { name: "userinfo" },
          disabled: false,
          text: this.$t("nav.userInfo")
        },
        {
          to: { name: "update-pwd" },
          disabled: true,
          text: this.$t("nav.changePassword")
        }
      ];
    }
  },
  methods: {
    submit() {
      let formHasErrors = true;

      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) {
          this.$refs[f].validate(true);
          formHasErrors = false;
        }
      });

      if (formHasErrors) {
        this.handleSubmit();
      }
    },

    async handleSubmit() {
      this.isLoading = true;
      try {
        const res = await account.changePassword({ ...this.form });
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.$toasted.success(this.$t("changePassword.success"));
          setTimeout(() => {
            this.$router.back();
          }, 500);
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./update-pwd.sass"></style>
